// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__DgFhc","advtTitle":"Advt_advtTitle__AbZ-f","firstLineTitle":"Advt_firstLineTitle__AaCYv","secondLineTitle":"Advt_secondLineTitle__Djqdi"};